import React from 'react';
import { ITextFieldProps, TextField } from '../../../../../../ui';
import { useDetailsFormContext } from '../../hooks/useDetailsFormContext';
import { useTranslation } from '../../../../i18n/translate/useTranslation';

export const Address = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useDetailsFormContext();

	return (
		<TextField
			label={t('parking_details_form_address_label')}
			placeholder={t('parking_details_form_address_placeholder')}
			invalid={!!errors.address}
			error={errors.address?.message}
			{...props}
			{...register('address')}
		/>
	);
};
